import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ApiKey } from 'dashboard/models/api-key';
import { Environment } from 'dashboard/models/environment';
import { setApiKeys } from 'dashboard/redux/slices/api-keys';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadApiKeyList({ currentEnvironment }: { currentEnvironment: Environment }) {
  return async (dispatch: Dispatch) => {
    const apiKeysResponse = await SessionClientDashboard.listResource<ApiKey, PaginationParams>(
      ApiEndpoint.ApiKey,
      { filter: { 'environment-id': currentEnvironment.id } },
    );

    const apiKeys = apiKeysResponse.data;
    dispatch(setApiKeys(apiKeys));
  };
}
